import { render } from "./Tarifs.vue?vue&type=template&id=b1e3cc06&ts=true"
import script from "./Tarifs.vue?vue&type=script&lang=ts"
export * from "./Tarifs.vue?vue&type=script&lang=ts"

import "./Tarifs.vue?vue&type=style&index=0&id=b1e3cc06&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__